module.exports = __webpack_public_path__ + "img/103.0c38ad50.png";